import { Label } from "flowbite-react";

const accessNested = (obj, key) =>
  key
    .split(".")
    .reduce(
      (_obj, _key) => (_obj && typeof _obj === "object" ? _obj[_key] : null),
      obj
    );

function InputToggle({
  name,
  label,
  labelPosition = "above", // accepted values "above","beside"
  formik,
  showError = true,
  id = "",
  readOnly,
  className,
  checked,
  error,
  required,
  onChange,
  disabled
}) {
  const formikValue = formik? accessNested(formik.values, name || id) : checked;
  const formikError = formik? accessNested(formik.errors, name || id) : error;
  const formikTouched = formik? accessNested(formik.touched, name || id) : "";
  const _required = formik? formik.isFieldRequired(name || id) : required;
  return (
    <div className={className || ""}>
      {label && labelPosition === "above" && (
        <Label
          className={`${
            _required && !readOnly
              ? "after:content-['_*'] after:text-red-500"
              : ""
          }`}
          htmlFor={id}
          value={label}
        />
      )}
      {/* <div className="mt-2">
        <ToggleSwitch
          label={label && labelPosition === "beside" ? label : ""}
          checked={formikValue}
          onChange={(e) => {
            if (!readOnly) {
              formik.setFieldValue(name || id, e);
              setTimeout(() => formik.setFieldTouched(name || id, true));
            }
          }}
        />
      </div> */}
      <div className="mt-2">
        <label className={`relative inline-flex items-center cursor-pointer`}>
          <input
            type="checkbox"
            checked={formikValue}
            onChange={(e) => {
              if (!readOnly) {
                formik && formik.setFieldValue(name || id, e.target.checked);
                setTimeout(() => formik && formik.setFieldTouched(name || id, true));
                onChange && onChange(e.target.checked);
              }
            }}
            disabled={disabled}
            className="sr-only peer"
          />
          <div className="w-11 h-6 bg-gray-200 peer-disabled:cursor-not-allowed  peer-disabled:!bg-gray-200/80 peer-focus:outline-none dark:peer-focus:ring-gray-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#293341]"></div>
          {labelPosition === "beside" && (
            <span
              className={`${
                _required && !readOnly
                  ? "after:content-['_*'] after:text-red-500"
                  : ""
              } ml-3 text-sm font-medium text-gray-900 dark:text-gray-300`}
            >
              {label}
            </span>
          )}
        </label>
      </div>
      {showError && (formik?.touched ? formikTouched : false) && (
        <p className="first-letter:uppercase mt-2 text-sm text-red-500">
          {formik?.errors ? formikError : ""}
        </p>
      )}
    </div>
  );
}

export default InputToggle;
